import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThirdwebProvider, ChainId } from "@thirdweb-dev/react";
import { ApolloProvider } from "@apollo/client";
import { apolloClient} from "./auth-fetcher";

const root = ReactDOM.createRoot(document.getElementById('root'));
const desiredChainId = ChainId.Mumbai;
root.render(
    <ThirdwebProvider desiredChainId={desiredChainId} clientId="1dd340fb1746ae8918c5d7d9bb8fbc68"
    chain="mumbai">
        <ApolloProvider client={apolloClient()}>
        <App />
        </ApolloProvider>
    </ThirdwebProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
